<script setup lang="ts">
import { inject } from 'vue'
import { useI18n } from 'vue-i18n'

const emptyResponse = inject('emptyResponse')
const specResponse = inject('specResponse')
const { t } = useI18n()
</script>

<template>
  <IDSKRow>
    <IDSKCol variant-desktop="two-thirds">
      <IDSKDetails open :title="t('zoppm.step0.spracovatel.spracovatel')">
        <IDSKHeading as="h3" variant="s" class="mb-1">{{
          t('zoppm.step0.spracovatel.komunikacia')
        }}</IDSKHeading>
        <IDSKParagraph>{{ t('zoppm.step0.spracovatel.komunikaciaDesc') }}</IDSKParagraph>
        <IDSKHeading as="h3" variant="s" class="mb-1">{{
          t('zoppm.step0.spracovatel.vykonavatel')
        }}</IDSKHeading>
        <ul class="govuk-list">
          <li>
            {{ specResponse.vykonavatel?.organRef?.nazov }}
          </li>
          <li>
            {{ t('zoppm.step0.spracovatel.ico') }}
            {{ specResponse.vykonavatel?.organRef?.ico }}
          </li>
          <li>
            {{ t('zoppm.step0.spracovatel.adresa') }}
            <Address :data="specResponse.vykonavatel?.adresa?.adresaUplna" />
          </li>
          <li>
            {{ t('zoppm.step0.spracovatel.email') }}
            {{ specResponse.vykonavatel?.kontakt?.email }}
          </li>
        </ul>

        <div
          v-for="(sprostredkovatel, index) in specResponse?.sprostredkovatelia"
          :key="sprostredkovatel.sprostredkovatel"
        >
          <IDSKHeading as="h3" variant="s" class="mb-1">{{
            t('zoppm.step0.spracovatel.sprostredkovateľ') + ' č. ' + (index + 1)
          }}</IDSKHeading>
          <ul class="govuk-list mb-0">
            <li>
              {{ sprostredkovatel?.organRef?.nazov }}
            </li>
            <li>
              {{ t('zoppm.step0.spracovatel.ico') }}
              {{ sprostredkovatel?.organRef?.ico }}
            </li>
            <li>
              {{ t('zoppm.step0.spracovatel.adresa') }}
              <Address :data="sprostredkovatel?.adresa?.adresaUplna" />
            </li>
            <li>
              {{ t('zoppm.step0.spracovatel.email') }}
              {{ sprostredkovatel?.kontakt?.email }}
            </li>
          </ul>
          <br />
        </div>
      </IDSKDetails>
    </IDSKCol>
  </IDSKRow>
</template>

<style lang="scss"></style>
